import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Home from './pages/Home';
import EventDetails from './pages/EventDetails';
import NotFound from './pages/NotFound';
import Error500 from './pages/Error500';
import Header from './pages/Header';
import Footer from './pages/Footer';

import EventEntryPage from './pages/EventEntryPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import LandingPage from './pages/LandingPage';
import AppsLandingPage from './pages/AppsLandingPage';
import EventsLanding from './pages/EventsLanding';
import DeleteAccountPage from './pages/DeleteAccountPage';


function App() {
 

  return (
    <Router>
      <Header />
      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<Navigate to="/apps/eventiq" replace />} />
          <Route path="/apps" element={<AppsLandingPage />} />
          <Route path="/apps/eventiq" element={<LandingPage />} />
          
          <Route path="/apps/eventiq/privacy" element={<PrivacyPolicy />} />
          <Route path="/apps/eventiq/terms" element={<TermsOfUse />} />
          <Route path="/apps/eventiq/events" element={<EventsLanding />} />
          <Route path="/apps/eventiq/delete-account" element={<DeleteAccountPage />} />
          <Route path="/apps/eventiq/event/:eventID" element={<EventDetails />} />
           {/* <Route path="/event/:eventID/dynamic/:inviteeID" element={<EventDetails />} /> */}
          <Route path="/apps/eventiq/event/:eventID/entry/:viewerID" element={<EventEntryPage />} />
          <Route path="/500" element={<Error500 />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );

}

export default App;
